import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2, ShoppingCart, ArrowRight } from 'lucide-react';
import { useCartStore } from '../store/useCartStore';
export function AddedToCartModal() {
  const {
    isAddedModalOpen,
    closeAddedModal,
    lastAddedProduct,
    openCart
  } = useCartStore();
  if (!lastAddedProduct) return null;
  return <AnimatePresence data-id="element-10" data-mp="24mn0flcpwxa9">
      {isAddedModalOpen && <>
          <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 pointer-events-none" data-id="element-11" data-mp="1gzeur2bdnm7p">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeAddedModal} className="fixed inset-0 bg-brand-blueDark/60 backdrop-blur-sm pointer-events-auto" data-id="element-12" data-mp="1c1d9caqhbat2" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col pointer-events-auto relative z-10" data-id="element-13" data-mp="t8hskh9dw39n">
              <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-14" data-mp="wd76g3sixwz">
                <div className="flex items-center gap-2 text-green-600" data-id="element-15" data-mp="5vhk9htu5fsl">
                  <CheckCircle2 className="w-6 h-6" data-id="element-16" data-mp="9tf7wg7yjttv" />
                  <h2 className="text-xl font-black" data-id="element-17" data-mp="ettju9cojnx6">Додано в кошик</h2>
                </div>
                <button onClick={closeAddedModal} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-18" data-mp="1ladwu7v6ql6l">
                  <X className="w-6 h-6 text-gray-500" data-id="element-19" data-mp="1qbbd2ewmx55g" />
                </button>
              </div>

              <div className="p-6" data-id="element-20" data-mp="3meg43tfu1jey">
                <div className="flex items-center gap-4 mb-8" data-id="element-21" data-mp="3ibb2dt3ktlrd">
                  <img src={lastAddedProduct.img} alt={lastAddedProduct.title} className="w-20 h-20 object-cover rounded-xl border border-gray-200" data-id="element-22" data-mp="3icui9ilblusm" />
                  <div data-id="element-23" data-mp="33llxbmsd4xlt">
                    <h3 className="font-bold text-brand-blue text-lg leading-tight mb-1" data-id="element-24" data-mp="33mx1hnpq07dg">
                      {lastAddedProduct.title}
                    </h3>
                    <p className="text-brand-muted font-medium" data-id="element-25" data-mp="3dboqbmzhibk5">
                      {lastAddedProduct.price} грн
                    </p>
                  </div>
                </div>

                <div className="flex flex-col gap-3" data-id="element-26" data-mp="38j5bkmp29adr">
                  <button onClick={openCart} className="w-full py-4 bg-brand-blue hover:bg-brand-blueDark text-white rounded-xl font-bold text-base tracking-wide shadow-button transition-colors duration-200 flex items-center justify-center gap-2" data-id="element-27" data-mp="2kuce2lssiuh1">
                    <ShoppingCart className="w-5 h-5" data-id="element-28" data-mp="105qowm06y6yz" />
                    Оформити замовлення
                  </button>
                  <button onClick={closeAddedModal} className="w-full py-4 border border-brand-blue/20 hover:bg-brand-bg text-brand-blue rounded-xl font-semibold text-base tracking-wide transition-colors duration-200 flex items-center justify-center gap-2" data-id="element-29" data-mp="mfetad4edq33">
                    Продовжити покупки
                    <ArrowRight className="w-4 h-4" data-id="element-30" data-mp="154uxbafak0o9" />
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}